'use client';

import { CSSProperties } from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

type BadgeProps = {
    name: string;
    /**
     * Overrides for the default colours, which are the cinema's surface palette. Pass CSS variables
     * (`bg-[var(--primary-color)]`) rather than literal colours — this app is themed per domain, and
     * a literal would ignore the cinema's palette.
     */
    className?: string;
    style?: CSSProperties;
};

function Badge(props: BadgeProps) {
    const { name, className, style } = props;

    return (
        <div
            className={cn(
                'flex h-26 flex-none rounded-4 px-8 py-2 text-body-bold-12 items-center whitespace-nowrap',
                'bg-[var(--surface-color)] text-[var(--on-surface-color)]',
                className
            )}
            style={style}>
            {name}
        </div>
    );
}

export default Badge;
